<template>
  <div class="linkage-box">
    <div class="lf-box">
      <div class="label">选择节点</div>
      <div class="select-box box">
        <div class="box-head">
          <div class="org">组织</div>
          <div class="node">节点名称</div>
        </div>
        <div class="box-body">
          <div class="org">
            <div
              v-for="item in orgList"
              :key="item.OrgId"
              :class="['org-item', activeOrg === item.OrgId ? 'active' : '']"
              @click="changeActive(item.OrgId)"
            >
              {{ item.OrgName }}
            </div>
          </div>
          <div class="node">
            <div v-show="nodeList.length === 0" class="none">没有相关节点</div>
            <el-checkbox-group v-model="checkedAllNode" @change="handleOrgChange">
              <el-checkbox
                v-for="ele in nodeList"
                :key="ele.NodeId + ele.NodeName"
                :label="`${ele.NodeName}`"
              ></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <div class="rt-box">
      <div class="label">已选择({{ selectNum }})</div>
      <div class="show-box box">
        <div class="box-head">
          <div class="org">组织</div>
          <div class="node">节点名称</div>
        </div>
        <div class="box-body">
          <div class="org">
            <div
              v-for="(item, i) in selectedOrg"
              :key="item.OrgId + i"
              :class="['org-item', activeRtOrg === item.OrgId ? 'active' : '']"
              @click="changeRightOrg(item.OrgId)"
            >
              {{ getOrgName(item.OrgId) }}
            </div>
          </div>
          <div class="node">
            <div v-for="(item, index) in rightNode" :key="item + index" class="right-node-item">
              <span>{{ item.NodeName }}</span>
              <i
                class="el-icon-circle-close delete-icon"
                @click="deleteRightNode(item.NodeName)"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tips">
      <span v-show="selectNum === 0" class="none-tip">
        <i class="el-icon-warning-outline"></i> 请选择共识节点
      </span>
      <span v-show="isShow && selectNum > 0" class="error-tip">
        <i class="el-icon-warning-outline"></i> {{ showTips }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LinkageBox',
  props: {
    algoForm: {
      type: Object,
      default: () => {
        return {
          Algorithm: 0
        }
      }
    },
    consensus: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // 右侧已选择
      activeRtOrg: '', // 右侧选中的组织
      selectedOrg: [], // 右侧显示的组织
      rightNode: [], // 右侧显示的当前组织的节点
      // 左侧选择节点部分
      activeOrg: '', // 当前激活的组织id
      activeOrgName: '', // 当前激活的组织名称
      orgList: [], // 显示的组织
      nodeList: [], // 显示的节点
      checkedAllNode: [], // 存储所有选中的节点
      nowShowChecked: [], // 当前显示的节点已经选中
      optionsTips: [
        { value: 0, tips: '共识为SOLO则节点只能选择1个', min: 1 },
        { value: 1, tips: '共识为TBFT至少需要选择4个节点', min: 4 },
        { value: 3, tips: '共识为MAXBFT至少需要选择4个节点', min: 4 },
        { value: 4, tips: '共识为RAFT则节点至少选择3个', min: 3 },
        { value: 5, tips: '共识为DPOS则节点至少选择4个', min: 4 }
      ],
      algoType: this.algoForm.Algorithm
    }
  },
  computed: {
    selectNum() {
      return this.checkedAllNode.length
    },
    minNode() {
      let item = this.optionsTips.filter(ele => ele.value === this.consensus)
      return item[0]['min']
    },
    showTips() {
      let item = this.optionsTips.filter(ele => ele.value === this.consensus)
      return item[0]['tips']
    },
    isShow() {
      if (this.consensus === 0) {
        return this.checkedAllNode.length !== 1
      } else {
        return this.checkedAllNode.length < this.minNode
      }
    }
  },
  watch: {
    algoForm: {
      deep: true,
      handler(val) {
        this.clearData()
        // 通知节点改变
        this.$emit('update:node', [])
        this.changeAlgo(val.Algorithm)
      }
    }
  },
  created() {
  },
  mounted() {
    this.algoType = this.algoForm.Algorithm
    this.getChainOrg()
  },
  methods: {
    // 修改算法
    changeAlgo(algo) {
      this.algoType = algo
      this.getChainOrg()
    },
    // 获取组织
    getChainOrg() {
      this.$apis.chain.getOrgByAlgo({ Algorithm: this.algoType }).then(res => {
        if (res && !this.$utils.isEmpty(res.data.items)) {
          this.orgList = res.data.items
          this.activeOrg = res.data.items[0]['OrgId']
          this.getOrgNode(this.activeOrg)
        } else {
          this.clearData()
        }
      })
    },
    clearData() {
      this.activeRtOrg = ''
      this.selectedOrg = []
      this.rightNode = []
      this.activeOrg = ''
      this.activeOrgName = ''
      this.orgList = []
      this.nodeList = []
      this.checkedAllNode = []
      this.nowShowChecked = []
    },
    // 获取去组织下的节点
    getOrgNode(orgId) {
      this.$apis.chain.getNodeByOrg({ OrgId: orgId, NodeType: 0 }).then(res => {
        if (res) {
          this.nodeList = res.data.items
        }
      })
    },
    // 切换激活组织
    changeActive(OrgId) {
      this.activeOrg = OrgId
      this.getOrgNode(OrgId)
    },
    // 组织选择改变
    handleOrgChange(val) {
      // 当前组织下选择了节点，处理右侧显示数据
      this.nowShowChecked = []
      this.nodeList.map(ele => {
        if (val.includes(ele.NodeName)) {
          this.nowShowChecked.push(ele)
        }
      })
      // length = 0 表示当前组织显示的节点已清空，右侧如果显示需要处理
      // length > 0 表示当前激活组织有选中的
      if (this.nowShowChecked.length > 0) {
        let param = {
          OrgId: this.activeOrg,
          nodeList: this.nowShowChecked
        }
        let index = this.selectedOrg.findIndex(ele => ele.OrgId === this.activeOrg)
        if (index !== -1) {
          this.$set(this.selectedOrg, index, param)
        } else {
          this.selectedOrg.push(param)
          this.activeRtOrg = param['OrgId']
        }
        this.rightNode = this.nowShowChecked
      } else {
        if (this.activeOrg === this.activeRtOrg) {
          this.deleteRightNode(this.rightNode[0]['NodeName'], 'linkDelete')
        }
      }
      // 在右侧没有选中的情况下，处理右侧选中组织
      if (this.selectedOrg.length > 0 && this.$utils.isEmpty(this.activeRtOrg)) {
        this.activeRtOrg = this.selectedOrg[0]['OrgId']
      }
      // 通知节点改变
      this.$emit('update:node', this.checkedAllNode)
    },
    // 右侧根据组织id显示组织名称
    getOrgName(id) {
      let index = this.orgList.findIndex(ele => ele.OrgId === id)
      return this.orgList[index]['OrgName']
    },
    // 切换右侧组织
    changeRightOrg(orgId) {
      this.activeRtOrg = orgId
      let item = this.selectedOrg.filter(ele => ele.OrgId === orgId)
      this.rightNode = item[0]['nodeList']
    },
    // 右侧节点删除
    deleteRightNode(nodeName, type = 'default') {
      // 删除节点显示
      let index = this.rightNode.findIndex(ele => ele.NodeName === nodeName)
      this.rightNode.splice(index, 1)
      // 处理左侧联动，右侧删除，左侧选中取消,只有右侧节点删除才调用
      if (type === 'default') {
        let lfIndex = this.checkedAllNode.findIndex(ele => ele === nodeName)
        this.checkedAllNode.splice(lfIndex, 1)
      }
      // 判断是否删除右侧显示的组织
      if (this.rightNode.length === 0) {
        let num = this.selectedOrg.findIndex(item => item.OrgId === this.activeRtOrg)
        this.selectedOrg.splice(num, 1)
        // 删除后处理右侧选中组织和显示节点
        if (this.selectedOrg.length > 0) {
          let last = this.selectedOrg.slice(-1)
          this.activeRtOrg = last[0]['OrgId']
          this.rightNode = last[0]['nodeList']
        } else {
          this.activeRtOrg = ''
          this.rightNode = []
        }
      }
      // 通知节点改变
      this.$emit('update:node', this.checkedAllNode)
    },
    // 父组件获取选中的数据
    getData() {
      let con1 =
        this.checkedAllNode.length < this.minNode && this.selectNum > 0 && this.consensus !== 0
      let con2 = this.checkedAllNode.length !== 1 && this.consensus === 0
      if (this.$utils.isEmpty(this.checkedAllNode)) {
        this.$message.warning('请选择共识节点！')
        this.$emit('change:disable')
        return false
      } else if (con1 || con2) {
        this.$message.warning(this.showTips)
        this.$emit('change:disable')
        return false
      } else {
        return this.selectedOrg
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'linkage-box',
  (
    --linkage-box-color: #fff,
    --linkage-box-border-color: #33496e,
    --linkage-box-background-active-color: #303c65cc,
    --linkage-box-background-color: #303c65,
    --linkage-box-none-tip-color: #c0c4cc,
    --linkage-box-tip-color: #f56c6c,
    --linkage-box-close-icon-color: #e95757,
    --linkage-box-box-content-node-none-color: #c0c4cc
  ),
  (
    --linkage-box-color: #192227,
    --linkage-box-border-color: #ebebeb,
    --linkage-box-background-active-color: #f4f4f5cc,
    --linkage-box-background-color: #f4f4f5,
    --linkage-box-none-tip-color: #c0c4cc,
    --linkage-box-tip-color: #f56c6c,
    --linkage-box-close-icon-color: #e95757,
    --linkage-box-box-content-node-none-color: #c0c4cc
  )
);
.linkage-box {
  @include adaptation(
    (
      --linkage-box-font-size: 12px,
      --linkage-box-tips-font-size: 14px,
      --linkage-box-label-margin-bottom: 8px,
      --linkage-box-box-width: 390px,
      --linkage-box-box-height: 370px,
      --linkage-box-box-margin-right: 24px,
      --linkage-box-border-width: 1px,
      --linkage-box-box-head-padding: 0 16px,
      --linkage-box-box-head-height: 40px,
      --linkage-box-box-head-org-col-width: 130px,
      --linkage-box-box-content-org-item-padding: 10px 16px,
      --linkage-box-box-content-org-item-line-height: 16px,
      --linkage-box-box-content-node-padding: 12px 16px,
      --linkage-box-box-content-node-checkbox-height: 36px,
      --linkage-box-box-content-right-node-height: 36px
    )
  );
  display: flex;
  align-items: center;
  font-size: var(--linkage-box-font-size);
  color: var(--linkage-box-color);
  .label {
    margin-bottom: var(--linkage-box-label-margin-bottom);
  }
  .box {
    width: var(--linkage-box-box-width);
    height: var(--linkage-box-box-height);
    border: var(--linkage-box-border-width) solid var(--linkage-box-border-color);
    margin-right: var(--linkage-box-box-margin-right);
    .box-head {
      display: flex;
      align-items: center;
      height: var(--linkage-box-box-head-height);
      line-height: var(--linkage-box-box-head-height);
      border-bottom: var(--linkage-box-border-width) solid var(--linkage-box-border-color);
      background-color: var(--linkage-box-background-color);
      .org {
        padding: var(--linkage-box-box-head-padding);
        width: var(--linkage-box-box-head-org-col-width);
        border-right: var(--linkage-box-border-width) solid var(--linkage-box-border-color);
      }
      .node {
        flex: 1;
        padding: var(--linkage-box-box-head-padding);
      }
    }
    .box-body {
      height: calc(var(--linkage-box-box-height) - var(--linkage-box-box-head-height));
      display: flex;
      align-items: center;
      .org {
        width: var(--linkage-box-box-head-org-col-width);
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        border-right: var(--linkage-box-border-width) solid var(--linkage-box-border-color);
        .org-item {
          padding: var(--linkage-box-box-content-org-item-padding);
          line-height: var(--linkage-box-box-content-org-item-line-height);
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          cursor: pointer;
        }
        .active {
          background: var(--linkage-box-background-active-color);
        }
      }
      .node {
        flex: 1;
        height: 100%;
        padding: var(--linkage-box-box-content-node-padding);
        overflow-y: auto;
        .el-checkbox {
          height: var(--linkage-box-box-content-node-checkbox-height);
        }
        .right-node-item {
          height: var(--linkage-box-box-content-right-node-height);
          line-height: var(--linkage-box-box-content-right-node-height);
          display: flex;
          align-items: center;
          justify-content: space-between;
          &:hover {
            opacity: 0.8;
          }
          .delete-icon {
            cursor: pointer;
            color: var(--linkage-box-close-icon-color);
          }
        }
      }
      .none {
        color: var(--linkage-box-box-content-node-none-color);
      }
    }
  }
  .tips {
    font-size: var(--linkage-box-tips-font-size);
    color: var(--linkage-box-none-tip-color);
    .error-tip {
      color: var(--linkage-box-tip-color);
    }
  }
}
</style>
